import apiClient from "./axios"

export const getNotificationDevices = async () => {
  const { data } = await apiClient.get("/notifications/devices")
  return data
}

export const sendTestNotification = async (payload = {}) => {
  const { data } = await apiClient.post("/notifications/test", payload)
  return data
}
